import React, { useEffect, useMemo, useState, useRef, useContext } from "react";
import FileIcon from "../File/file";
import Info from "../Info/info";
import InfoTitle from "../Info/InfoTitle";
import styles from "../Add Beneficiary/styles/new_beneficiary.module.css";
import Upload from "../Upload/upload";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";

import "./styles/phone.css";
import { Switch } from "@mui/material";
import { Beneficiarytrustee } from "../Beneficiarytrustee/Beneficiarytrustee";
import PartnerSharingPerson, {
  EMPTY_PERSON_SHARING,
  personSharingValue,
} from "../Partner Sharing/PartnerSharingPerson";
import { getPartner } from "../Partner Sharing/PartnerSharing";
import { isPendingApproval } from "../../../Utils/partnerApproval";
import { canEditRecord } from "../../../Utils/partnerApproval";
import {
  canEditAnything,
  changedFields,
  editablePersonSections,
  mergeProposedIds,
  readProposals,
  viewablePersonSections,
} from "../../../Utils/partnerPropose";
import ProposedField from "../Partner Sharing/ProposedField";
import proposed from "../Partner Sharing/styles/ProposedField.module.css";
import ViewOnly from "../../ViewOnly";
import AssetType from "../Asset Type/AssetType";
import AddNewAsset from "../Add Beneficiary/AddNewAsset";
import AddBeneficiary from "../Add Asset/AddBeneficiary";
import { UserData } from "../../../Context/DataContext";
import { RandomId } from "../../../Utils/RandomId";
import { useScrollLock } from "../../../Utils/useScrollLock";
import {
  DeleteFile,
  downloadFile,
  downloadLocalFile,
  UploadFiles,
  fetchDecryptedFile,
} from "../../../Utils/UploadFile";
import { OnProgress } from "../My Account/OnProgress";
import config from "../../../config";
import Confirmation from "../../Confirmation/Confirmation";
import { handleIssues } from "../../../Utils/handleIssues";
import { isValidDateFormat } from "../../../Utils/isValidDateFormat";
import { isValidFileSize } from "../../../Utils/isValidFileSize";
import { floatMessage } from "../../../Utils/floatMessage";
import CCCalendar from "../CC Calendar/CCCalendar";
import { createAccess, sendEmail } from "../../../Utils/beneficiary";

import parse from "html-react-parser";
import { useAuth } from "../../../Context/AuthContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import uploadButton from "./styles/img/upload_button.png";
import useWindowDimensions from "../../Footer/footer";
import { Upload as UploadProfilePicture } from "antd";
import { DeleteOutlined, DownOutlined } from "@ant-design/icons";
import CropperImage from "antd-cropper-img";
import editButton from "./styles/img/edit_button.svg";
import { NewEmailField } from "../Add Beneficiary/newEmailField";
import plus_button from "./styles/img/plus_button.svg";
import { encryptFileAES } from "../../../Utils/OstreonEncryption";
import { buildPrivateKey } from "../../../Utils/beneficiaryUtils";
import {
  RELATIONSHIP_OPTIONS,
  withAddedFields,
  isMinor,
} from "../../../Utils/minorBeneficiary";
const base_url = config.base_url;
function EditBeneficiary({ toEdit, onClose, openAssets }) {
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const [previewImage, setPreviewImage] = useState(
    toEdit.profile_avatar ? toEdit.profile_avatar : null
  );
  const [openPersonalMessage, setOpenPersonalMessage] = useState(
    toEdit.message.length > 0 || toEdit.personal_documents.length > 0
      ? true
      : false
  );

  const [initialImage, setInitialImage] = useState(
    toEdit.profile_avatar ? toEdit.profile_avatar : null
  );

  const [image, setImage] = useState(null);
  const [extension, setExtension] = useState(
    toEdit.profile_avatar
      ? () => {
          let extension = toEdit.profile_avatar[0];

          if (extension === "/") extension = ".jpg";
          else if (extension === "i") extension = ".png";
          return extension;
        }
      : null
  );

  const divElementRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const { height, width } = useWindowDimensions();

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.EditBeneficiary.EditBeneficiary
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.EditBeneficiary.EditBeneficiary);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const [showImageCrop, setShowImageCrop] = useState(false);
  useEffect(() => {}, []);
  const [modal, setModal] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [files, setFiles] = useState([]);
  const userData = UserData();
  const auth = useAuth();
  /*
    Counted, not set directly -- the same lock <OnProgress> takes while this
    saves. Setting `documentElement.style.overflow` here instead meant
    OnProgress captured "hidden" as the value to put BACK, so when the save
    finished and this popup closed itself, the restore handed the page
    "hidden" and it could no longer scroll. Reopening and closing without
    saving cleared it, which is what made it look intermittent.
  */
  useScrollLock();
  const [error, setError] = useState({
    name: "",
    priority: "",
    email: "",
    // TODO: un-comment this field for adding multipe benef. emails
    email_2: "",
    email_3: "",
    phone_number: "",
    birth_date: "",
    message: "",
    personal_documents: "",
  });
  const [beneficiary, setBeneficiary] = useState({
    user_id: toEdit?.user_id,
    name: toEdit?.name,
    priority: toEdit?.priority,
    message: toEdit?.message,
    email: toEdit?.email,
    phone_number: toEdit?.phone_number,
    awareness_status: toEdit?.awareness_status,
    // TODO: un-comment this field for adding multipe benef. emails
    awareness_status_2: toEdit?.awareness_status_2,
    awareness_status_3: toEdit?.awareness_status_3,
    birth_date: toEdit?.birth_date,
    personal_documents: toEdit?.personal_documents,
    visible_assets: toEdit?.visible_assets,
    trustees: toEdit?.trustees,
    personal_code: toEdit?.personal_code,
    deleted_files: [],
    profile_avatar: toEdit?.profile_avatar,
    deleted_trustees: [],
    deleted_assets: [],
    email_2: toEdit?.email_2,
    email_3: toEdit?.email_3,
    /*
      A beneficiary saved before these existed has neither, and
      `withAddedFields` supplies the defaults: not a minor, no relationship.
    */
    is_minor: withAddedFields(toEdit).is_minor,
    relationship: withAddedFields(toEdit).relationship,
    /*
      Seeded from the beneficiary being edited, so the switches show what is
      actually shared. One saved before these existed has neither, and both
      default off.
    */
    /*
      Every sharing flag this record carries, read from one place.

      Listed by hand this went wrong twice over: a row added later was
      missed here and missed again in the save, so switches the customer
      set came back off. personSharingValue projects the key set from
      EMPTY_PERSON_SHARING, with `=== true` throughout -- a record saved
      before a flag existed has granted nothing, and `undefined` is not a
      permission.
    */
    ...personSharingValue(toEdit),
    /*
      The partner's outstanding suggestions. Left out, every save by the
      customer would silently discard every suggestion they had not answered.
    */
    partner_changes: Array.isArray(toEdit?.partner_changes)
      ? toEdit.partner_changes
      : [],
    /*
      Carried through because this object is what the save writes back, so a
      field left out is dropped. pending_approval is not here: the save sets it
      deliberately, since saving is approving. Who created it outlives that.
    */
    created_by_partner: toEdit?.created_by_partner || "",
  });
  /*
    Null when this user has no partner, which is what hides the section.
  */
  const partner = getPartner(userData);

  /*
    Opened to review something the partner created. The modal is the same one in
    every other respect -- every field is editable, exactly as the approval
    interstitial promises -- and only the confirming button changes: saving IS
    approving, so it says so.
  */
  const awaitingApproval = isPendingApproval(toEdit);
  /*
    Read-only: a partner looking at something the customer wrote.

    They may read what was shared and nothing else. Save and Delete are not
    rendered, and every control that assigns or uploads is withheld, so the
    only things left are reading and closing. Editing is possible for exactly
    one case -- their own draft the customer has not approved -- which is what
    canEditRecord decides.

    The writers in this view are stubbed too, so nothing could persist even if
    a control were missed; this is what makes that visible rather than a
    surprise.
  */
  const readOnly = !canEditRecord(userData, toEdit);

  /*
    ---- partner edits, both directions ----

    The same pair as on an asset, with two permissions instead of five: who
    this person is, and how to reach them. A granted section stays live
    inside the otherwise read-only modal, Save becomes "propose", and the
    customer sees what was proposed at the top of their own copy.
  */
  const personSections = editablePersonSections(toEdit);
  /*
    What this partner may SEE, which is a different question from what they
    may change -- and the one an "add" control answers to.

    A row that is shared and empty arrives looking exactly like a row that was
    never shared: an empty list either way. Without this the + was hidden from
    every partner, so a granted row read as though it had nothing to do with
    them. Shown when the row is theirs to see; only an EDIT makes it do
    anything, and that is ViewOnly's job -- the region is marked editable only
    where the edit was granted, so otherwise the control renders and takes no
    clicks. Same arrangement as Edit Trusted Advisor.
  */
  const personViews = viewablePersonSections(toEdit);
  const canSeeTrustees = !readOnly || personViews.trustees;
  const canSeeAssets = !readOnly || personViews.assets;
  const canPropose =
    readOnly &&
    Boolean(userData.partnerPropose) &&
    canEditAnything("beneficiary", toEdit);
  const editableIf = (on) =>
    canPropose && on ? { "data-viewonly-editable": "" } : {};
  /*
    The documents under the personal message, specifically.

    Their controls are an upload tile and a delete handle rather than form
    fields, so ViewOnly's `disabled` never reaches them and each has to be
    gated by hand -- the same arrangement Edit Asset makes for its own
    documents.

    A partner adding one here is proposing it: the file is uploaded (it has
    to exist before a list can name it) and the NEW LIST is what waits for
    the customer. Removing one proposes the shorter list and deletes
    nothing; the file stays until the customer accepts, because a refused
    proposal must leave the record exactly as it was.
  */
  const canEditDocuments = !readOnly || (canPropose && personSections.message);
  /*
    The picture's own controls -- the cropper and the upload tile.

    Theirs are an overlay and a file input rather than form fields, so
    ViewOnly's `disabled` does not reach them: without this the picker
    opened for a partner who had not been granted the row, let them choose
    an image, and then dropped it at save time, because `changedFields`
    filters out what they may not propose. A control that cannot do
    anything should not be offered.
  */
  const canEditPicture = !readOnly || (canPropose && personSections.picture);
  /*
    Whose storage a file belongs in: the customer's when a partner is the one
    attaching it, their own otherwise. /file/upload writes into the session
    user's directory, which for a partner is one the customer cannot read.

    Keyed on partnerReadOnly, not readOnly -- that is true of the whole view,
    including a draft the partner may still edit.
  */
  const uploadTarget = userData.partnerReadOnly
    ? userData.UserData?.user_id
    : null;

  const [proposals, setProposals] = useState({});
  const [decisions, setDecisions] = useState({});

  /*
    A partner's proposal as it would actually land, which for the asset row
    is not what they sent.

    `visible_assets` is a list of ids and the list they were shown had the
    withheld ones taken out -- /customer/shared intersects it with the
    assets whose own switch is on. So their edit covers the visible half and
    says nothing about the rest, and the rest has to survive it: accepting
    their list as given would drop every asset on this beneficiary the
    partner was never allowed to see.

    Resolved here rather than at the point of acceptance so the switch is
    about what saving would really keep. Same arrangement as the two
    relation rows in Edit Trusted Advisor, down to the helper.
  */
  const partnerCouldSee = (id) =>
    (userData.UserData?.assets || []).find((a) => a.asset_id === id)
      ?.share_with_partner === true;

  const resolvedProposals = useMemo(() => {
    const out = {};
    for (const [field, change] of Object.entries(proposals)) {
      out[field] =
        field === "visible_assets"
          ? {
              ...change,
              /*
                Ids for assets that no longer exist are dropped first.

                Refusing a partner's asset deletes it, and the attachment
                they proposed for it outlives the asset: the proposal is a
                list of ids, written before the refusal. Deleting prunes the
                proposal when that was all it asked for, but one that still
                says something keeps the dead id, and accepting it would
                attach this beneficiary to an asset that is not there.
              */
              value: mergeProposedIds(
                toEdit?.visible_assets,
                (Array.isArray(change?.value) ? change.value : []).filter(
                  (id) =>
                    (userData.UserData?.assets || []).some(
                      (a) => a.asset_id === id
                    )
                ),
                partnerCouldSee
              ),
            }
          : change;
    }
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposals, toEdit]);
  useEffect(() => {
    let live = true;
    (async () => {
      const read = await readProposals(toEdit, userData.private_key);
      if (live) setProposals(read);
    })();
    return () => {
      live = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toEdit?.user_id]);

  /*
    One switch, directly above the field it is about, and the field outlined
    to match. Nothing for a field nobody has proposed a change to, and
    nothing at all on the partner's own screen -- they are the ones asking.
  */
  const review = (field, label, children = null) => (
    <ProposedField
      field={field}
      label={label}
      proposals={resolvedProposals}
      decisions={decisions}
      onDecide={decideProposal}
      active={!readOnly}
      disabled={userData.isFreezed}
    >
      {children}
    </ProposedField>
  );
  // The purple outline, for a box (`field`) or for a whole region (`block`).
  const reviewMark = (field, kind = "field") =>
    !readOnly && resolvedProposals[field] ? proposed[kind] : "";
  // Whether the picture specifically has a question waiting; see its row.
  const reviewingAvatar = !readOnly && Boolean(proposals.profile_avatar);

  /*
    Every suggestion arrives accepted.

    The alternative is a modal that opens showing the customer's own values
    with switches offering something they have to flip one at a time to even
    see. Starting from the partner's version means the record reads as it
    WOULD read if they saved, and refusing one is a single flip back -- which
    is also what makes saving an answer to all of them rather than only to
    the ones that were touched.

    Once per record, and never on the partner's own screen: they are the ones
    asking, and pre-filling their form with their own pending proposal would
    have them re-propose it.
  */
  const defaultsApplied = useRef(false);
  useEffect(() => {
    if (defaultsApplied.current || readOnly) return;
    const fields = Object.keys(resolvedProposals);
    if (!fields.length) return;
    defaultsApplied.current = true;
    setDecisions(Object.fromEntries(fields.map((field) => [field, true])));
    setBeneficiary((prev) => {
      const next = { ...prev };
      for (const field of fields) {
        // The picture goes through decideAvatar, not into this object.
        if (field === "profile_avatar") continue;
        next[field] = resolvedProposals[field]?.value;
      }
      return next;
    });
    if (fields.includes("profile_avatar")) decideAvatar(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposals, readOnly]);

  /*
    A picture is not a field, so answering one is not an assignment.

    What the save actually reads is `image` (the bytes to upload) and
    `initialImage` (whether there is a picture at all) -- writing base64 into
    `beneficiary.profile_avatar` would change nothing, and the field is on no
    schema anyway. So this puts the decision where the save will find it.

    The partner's suggestion arrives as a REFERENCE, not as the image: they
    uploaded it to the file store and proposed `{ file, name }`, because the
    bytes are megabytes and a proposal is a row in a document. Accepting one
    fetches it back, under the same key it was written with.
  */
  const avatarBase64 = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result).split(",")[1]);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    });

  const decideAvatar = async (takeNew) => {
    if (!takeNew) {
      // Back to the customer's own, whatever that was -- including none.
      setImage(null);
      setPreviewImage(toEdit?.profile_avatar || null);
      setInitialImage(toEdit?.profile_avatar || null);
      return;
    }
    const proposed = proposals.profile_avatar?.value;
    if (!proposed?.file) {
      // The partner suggests removing it. Both empty is what the save reads
      // as "delete the picture".
      setImage(null);
      setPreviewImage(null);
      setInitialImage(null);
      return;
    }
    try {
      const file = await fetchDecryptedFile(
        proposed.file,
        proposed.name || "picture",
        userData.private_key
      );
      const base64 = await avatarBase64(file);
      if (!base64) return;
      setImage(file);
      setPreviewImage(base64);
      setInitialImage(base64);
      setExtension(base64[0] === "i" ? ".png" : ".jpg");
    } catch (error) {
      /*
        Unreadable. The customer's own picture stays -- clearing it on the
        strength of a suggestion that will not open would be worse -- but
        this used to happen in silence, so the switch moved and the image
        did not, and there was nothing to tell them which.
      */
      console.log(error);
      setDecisions((prev) => ({ ...prev, profile_avatar: false }));
      floatMessage(
        approvalContent?.partnerApprovalText27 ||
          "That suggested picture could not be loaded",
        "error"
      );
    }
  };

  const decideProposal = (field, takeNew) => {
    setDecisions((prev) => ({ ...prev, [field]: takeNew }));
    if (field === "profile_avatar") {
      decideAvatar(takeNew);
      return;
    }
    const value = takeNew ? resolvedProposals[field]?.value : toEdit?.[field];
    setBeneficiary((prev) => ({ ...prev, [field]: value }));
  };
  const approvalContent =
    websiteCurrentLang?.content?.User?.PartnerApproval?.PartnerApproval;
  const minor = isMinor(beneficiary);
  //  TODO: un-comment this field for adding multipe benef. emails
  const [benefEmailFields, setBenefEmailFields] = useState([]);
  // TODO: un-comment this field for adding multipe benef. emails
  useEffect(() => {
    if (toEdit?.email_2?.trim().length > 0) {
      setBenefEmailFields((prev) => [
        ...prev,

        {
          id: Math.random().toFixed(4),
          email: toEdit.email_2,
        },
      ]);
    }
    if (toEdit?.email_3?.trim().length > 0) {
      setBenefEmailFields((prev) => [
        ...prev,
        {
          id: Math.random().toFixed(4),
          email: toEdit.email_3,
        },
      ]);
    }
  }, []);

  function encodeFileToBase64(file) {
    if (!file) return;
    const base64String = new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Callback function to handle the file reading operation
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // Extract base64 string (remove data URL prefix)
        resolve(base64String); // Resolve with the base64 string
      };

      // Callback function to handle errors during file reading
      reader.onerror = (error) => {
        reject(error); // Reject with the error object
      };

      // Read the file as a data URL
      reader.readAsDataURL(file);
    });
    let extension = base64String[0];

    if (extension === "/") extension = ".jpg";
    else if (extension === "i") extension = ".png";
    setExtension(extension);
    return base64String;
  }
  const uploadImageHandler = async (file) => {
    const formData = new FormData();
    const encrypted_image = await encryptFileAES(userData.private_key, file);
    formData.append("file", encrypted_image);
    formData.append("profile_id", toEdit.user_id);
    await fetch(base_url + "user/profile/pic/upload", {
      method: "POST",
      mode: "cors",
      body: formData,
      credentials: "include",
    })
      .then((res) => res.json())
      .then(async (res) => {
        await userData.getCustomerBeneficiary();
      })
      .then(() => {});
  };
  const deleteImageHandler = async () => {
    // setLoading(true);
    await fetch(base_url + "user/profile/pic/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `profile_id=${toEdit.user_id}`,
      credentials: "include",
    })
      .then((res) => res.json())
      .then(async (res) => {
        setPreviewImage(null);
        setExtension(null);
        setImage(null);
        setInitialImage(null);
      });
  };
  const [duplicatedName, setDuplicatedName] = useState(false);
  const duplicateError = content.EditBeneficiaryError1;
  const maxFilesToUpload = "8";
  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const textareaRef = useRef(null);

  const handleChangeDescription = () => {
    const textarea = textareaRef.current;
    // Reset the textarea height to 0 to correctly calculate the scrollHeight
    textarea.style.height = "0";
    const height = textarea.scrollHeight;
    textarea.style.height = `${height}px`;
  };
  // textarea
  const handleDeletedData = () => {
    beneficiary.deleted_files.map((file_id) => {
      return DeleteFile(file_id)
        .then(() => {
          console.log(`File deleted ${beneficiary.name}:${file_id}`);
        })
        .catch((e) => {
          console.log(`File not deleted ${beneficiary.name}:${file_id}`);
        });
    });
    // var new_assets = [...userData.UserData.assets]
    var new_assets = userData.UserData.assets.map((asset) => {
      if (beneficiary.deleted_assets.includes(asset.asset_id)) {
        return {
          ...asset,
          beneficiaries: asset.beneficiaries.filter(
            (e) => e !== beneficiary.user_id
          ),
        };
      } else {
        return asset;
      }
    });
    return new_assets;
  };
  const Progress = (status) => {
    setModal(
      <OnProgress title={dublicatedcontent?.work_in_progress} status={status} />
    );
  };
  const handleSave = async (e) => {
    e.preventDefault();

    if (validateData()) {
      console.log("Data is invalid");
      return;
    }

    /*
      A partner's save is a proposal and stops here: nothing below runs, so
      the customer's beneficiary, their assets and their tree are untouched
      until the customer accepts it.
    */
    if (canPropose) {
      const fields = changedFields("beneficiary", toEdit, beneficiary);
      if (!fields.length) {
        onClose();
        return;
      }
      /*
        Uploaded first, as on an asset: the proposed list names them, and a
        name pointing at nothing would be accepted by the customer and then
        fail to open. Nothing is deleted here -- see canEditDocuments.
      */
      if (fields.includes("personal_documents") && files.length) {
        await UploadFiles(
          files,
          userData.private_key,
          Progress,
          dublicatedcontent,
          uploadTarget
        );
        setModal(null);
      }
      /*
        A picture travels as a FILE, never as the field.

        `profile_avatar` holds the whole image as base64 -- megabytes of it --
        and a proposal is a row in the customer's document sent through a
        form-encoded request. Sending the bytes put an 8MB body against a 1MB
        limit and the save died with a 413 the partner could not act on.

        So the image goes to the file store, encrypted under the CUSTOMER's
        key exactly as a document is, and what is proposed is the reference.
        The customer's side fetches it back when they accept.
      */
      const values = { ...beneficiary };
      /*
        Which files each change names, in plaintext, so the server knows
        they are spoken for -- see proposeChanges. Without this the orphan
        sweeper deletes a partner's upload the moment the customer next
        loads their data, and the suggestion points at nothing.
      */
      const named = {};
      if (fields.includes("personal_documents")) {
        named.personal_documents = (beneficiary.personal_documents || [])
          .map((file) => file?.id)
          .filter(Boolean);
      }
      if (fields.includes("profile_avatar")) {
        if (image) {
          const id = RandomId(32);
          // Not `named`: that is the map of proposed file ids just above,
          // and shadowing it here meant the id was recorded on this File
          // object instead of in the map -- so the proposal named no files
          // and the orphan sweeper deleted the upload moments later.
          const namedFile = new File([image], id, { type: image.type });
          /*
            The reference is recorded only if the bytes really landed.

            An upload that fails here used to leave the proposal pointing at
            a file that was never written: the customer saw the question,
            flipped it, and their own picture stayed put with nothing on
            screen to say why. Better to refuse the whole save and say so --
            the partner can try again, and nothing is queued meanwhile.
          */
          try {
            await UploadFiles(
              [namedFile],
              userData.private_key,
              Progress,
              dublicatedcontent,
              uploadTarget
            );
          } catch (error) {
            console.log(error);
            setModal(null);
            floatMessage(
              approvalContent?.partnerApprovalText26 ||
                "Could not send those changes",
              "error"
            );
            return;
          }
          setModal(null);
          values.profile_avatar = { file: id, name: image.name || id };
          named.profile_avatar = [id];
        } else {
          // Removed rather than replaced; null is the whole of the message.
          values.profile_avatar = null;
        }
      }
      await userData.partnerPropose(
        "beneficiary",
        toEdit.user_id,
        fields,
        values,
        named
      );
      onClose();
      return;
    }
    var new_assets = handleDeletedData();
    new_assets = new_assets.map((asset) => {
      if (beneficiary.visible_assets.includes(asset.asset_id)) {
        return {
          ...asset,
          beneficiaries: [
            ...new Set([...asset.beneficiaries, beneficiary.user_id]),
          ],
        };
      } else {
        return asset;
      }
    });
    /*
      The picture this save is committing, as the rest of the app must see it.

      `new_beneficiaries` below is built from `beneficiary`, which still
      holds the avatar the modal OPENED with -- the blocks underneath set
      the new one through setBeneficiary, which updates this modal's own
      state and nothing else, and the modal is closing. So the record handed
      to setUserData carried the old picture, and the card in the tree went
      on drawing it until the page was reloaded and the server asked again.

      Three cases, and they are the same three the upload block makes: no
      picture at all, a newly chosen one, or the one already there.
    */
    const savedAvatar =
      !image && !initialImage
        ? null
        : image
        ? previewImage
        : beneficiary.profile_avatar;

    let new_beneficiaries = userData.UserData.beneficiaries.map(
      (beneficiary_) => {
        if (beneficiary_.user_id === beneficiary.user_id) {
          /*
            Saving a partner-created beneficiary is the approval. The flag is
            cleared here and only here; created_by_partner is left alone,
            because who created it stays true after it is accepted.
          */
          return {
            ...beneficiary,
            // See savedAvatar above: what the save is actually committing.
            profile_avatar: savedAvatar,
          /*
            And the partner's suggestions, settled -- all of them.

            Saving IS the answer. Every suggestion arrives with its switch
            on, so a value the customer left alone is one they kept and a
            switch they turned off is one they refused; either way the
            question has been put, and none of them comes back. Leaving the
            untouched ones queued would ask again about changes already in
            the record.
          */
            partner_changes: [],
            pending_approval: false,
          };
        } else return beneficiary_;
      }
    );
    if (!image && !initialImage) {
      setBeneficiary((prev) => {
        return {
          ...prev,
          profile_avatar: null,
        };
      });
      await deleteImageHandler();
      await userData.getCustomerBeneficiary();
    } else if (image) {
      setBeneficiary((prev) => {
        return {
          ...prev,
          profile_avatar: previewImage,
        };
      });
      uploadImageHandler(image);
      // await userData.getCustomerBeneficiary();
    }

    UploadFiles(files, userData.private_key, Progress, dublicatedcontent)
      .then(async () => {
        Progress(content.EditBeneficiaryText1);
        var new_issues = handleIssues({
          ...userData.UserData,
          beneficiaries: new_beneficiaries,
          assets: new_assets,
        });
        userData.setUserData({
          ...userData.UserData,
          beneficiaries: new_beneficiaries,
          assets: new_assets,
          issues: new_issues,
        });
        userData.setCustomerUser({
          ...userData.CustomerUser,
          user_status: new_assets.some((e) => e.beneficiaries.length > 0)
            ? "Active"
            : "Inactive",
        });
        userData.Update(RandomId(10));

        return Promise.all([
          buildPrivateKey(
            userData.private_key,
            beneficiary?.email,
            beneficiary?.birth_date,
            beneficiary?.personal_code
          ),
          beneficiary?.email_2
            ? buildPrivateKey(
                userData.private_key,
                beneficiary?.email_2,
                beneficiary?.birth_date,
                beneficiary?.personal_code
              )
            : undefined,
          beneficiary?.email_3
            ? buildPrivateKey(
                userData.private_key,
                beneficiary?.email_3,
                beneficiary?.birth_date,
                beneficiary?.personal_code
              )
            : undefined,
        ]);
      })
      .then(async (beneficiary_accesses) => {
        const body = {
          email: beneficiary.email,
          beneficiary_user_id: beneficiary.user_id,
          accesses: beneficiary_accesses,
        };
        /*
          "add" when this is an approval, "edit" otherwise.

          A partner-created beneficiary has no login account: the partner's
          create path deliberately does not make one, because a beneficiary
          nobody has approved should not have credentials. So the account is
          created at the moment of approval -- which is also when the
          beneficiary first becomes real.

          Sending "edit" here instead would reach EditBeneficiary, which loads
          the CustomerBeneficiary record and Object.assigns onto it. There is
          none, so it would assign onto null and throw, and the approval would
          fail with nothing on screen to explain why.
        */
        return createAccess(body, awaitingApproval ? "add" : "edit");
      })
      .then(() => {
        let beneficiary_emails = [];
        if (
          beneficiary.awareness_status === "true" &&
          toEdit.awareness_status === "false"
        )
          beneficiary_emails.push(beneficiary?.email);
        if (
          beneficiary.awareness_status_2 === "true" &&
          toEdit.awareness_status_2 === "false"
        )
          beneficiary_emails.push(beneficiary?.email_2);
        if (
          beneficiary.awareness_status_3 === "true" &&
          toEdit.awareness_status_3 === "false"
        )
          beneficiary_emails.push(beneficiary?.email_3);
        if (beneficiary_emails.length > 0) {
          Progress(content.EditBeneficiaryError3);
          sendEmail(beneficiary, "beneficiary", beneficiary_emails)
            .then((e) => {
              auth.setAwarenessEmail(auth.awareness_email + 1);
            })
            .catch((e) => {
              Progress(e);
              setTimeout(() => {
                setModal(null);
                onClose();
              }, 3000);
            });
        } else {
          setModal(null);
        }
        onClose();
        floatMessage(dublicatedcontent?.saved);
        return;
      })
      .catch((e) => {
        console.log(e);
        Progress(dublicatedcontent.dublicatedText78);
        setTimeout(() => {
          setModal(null);
          onClose();
        }, 5000);
      });
  };
  /*
    Run through a catch rather than fired and forgotten.

    These savers are async, so anything they throw becomes a rejected promise
    nobody is holding: the button does nothing, there is no message, and
    nothing on screen says which line gave up. That is how a JSON.parse of an
    empty string hid through a whole round of testing. Logging it does not
    fix a failure, but it stops one being silent.
  */
  const runSave = (e) => {
    handleSave(e).catch((error) => console.log(error));
  };
  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const validateData = () => {
    var errors_ = {};
    var isError = false;
    /*
      A partner is checked only on what they were given.

      Their copy of this record is the shared part of it and nothing else: a
      date of birth has no sharing flag at all, so theirs is always "", and an
      email the customer withheld is "" too. Run over that, the checks below
      fail the save on fields that are not on their screen and cannot be put
      right from it -- which is exactly what "Propose changes does nothing"
      was. Nothing was wrong with their edit; the form was rejecting the
      absence of everything around it.

      Gated on what they may actually change, so a field they can only read
      is not theirs to be failed on either -- the customer validated it when
      they saved it. Every flag is true for the customer, so their own save
      is unchanged.
    */
    const checks = {
      identity: !canPropose || personSections.identity,
      /*
        A beneficiary's contact details are view-only -- there is no edit
        flag for them at all -- so this is always false for a partner, and
        their copy of a withheld address is "" either way.
      */
      contact: !canPropose || personSections.contact,
      // The personal message and the files under it, behind their own row.
      message: !canPropose || personSections.message,
      /*
        The date of birth. No row covers it, so a partner never has one to
        check and theirs is always "".
      */
      private: !canPropose,
    };
    if (checks.contact && !isValidEmail(beneficiary.email)) {
      errors_["email"] = dublicatedcontent?.dublicatedText47;
      isError = true;
    }
    // TODO: un-comment this field for adding multipe benef. emails

    if (
      checks.contact &&
      !isValidEmail(beneficiary.email_2) &&
      benefEmailFields.length > 0
    ) {
      console.log(beneficiary);
      errors_["email_2"] = dublicatedcontent.dublicatedText47;
      isError = true;
    }
    if (
      checks.contact &&
      isValidEmail(beneficiary.email_2) &&
      benefEmailFields.length > 0 &&
      beneficiary.email_2 === beneficiary.email
    ) {
      errors_["email_2"] = dublicatedcontent.dublicatedText281;
      isError = true;
    }

    // TODO: un-comment this field for adding multipe benef. emails
    if (
      checks.contact &&
      benefEmailFields.length > 1 &&
      !isValidEmail(beneficiary.email_3)
    ) {
      errors_["email_3"] = dublicatedcontent.dublicatedText47;
      isError = true;
    }
    if (
      checks.contact &&
      benefEmailFields.length > 1 &&
      isValidEmail(beneficiary.email_3) &&
      (beneficiary.email_3 === beneficiary.email_2 ||
        beneficiary.email_3 === beneficiary.email)
    ) {
      errors_["email_3"] = dublicatedcontent.dublicatedText281;
      isError = true;
    }

    if (checks.identity && beneficiary.name === "") {
      errors_["name"] = dublicatedcontent?.dublicatedText214;
      isError = true;
    }

    // check if beneficiary with this name is exist
    if (checks.identity && beneficiary.name !== "") {
      const editedBenName = beneficiary.name;
      const editedBenId = beneficiary.user_id;
      let hasMatchingBen = userData.UserData.beneficiaries.some(
        (benItem) =>
          benItem.name.toLowerCase() === editedBenName.toLowerCase() &&
          benItem.user_id !== editedBenId
      );

      if (hasMatchingBen) {
        isError = true;
        setDuplicatedName(true);
        document.getElementById("scrollContainer").scrollTop = 0;
      }
    }

    if (checks.private && !isValidDateFormat(beneficiary.birth_date)) {
      errors_["birth_date"] = dublicatedcontent?.dublicatedText48;
      isError = true;
    }
    if (checks.identity && beneficiary.priority === "") {
      errors_["priority"] = dublicatedcontent?.dublicatedText215;
      isError = true;
    }
    if (checks.message && beneficiary.message.length > maxMessageLength) {
      errors_["message"] =
        "The message is too big. Please reduce the number of characters";
      isError = true;
    }
    if (
      checks.message &&
      beneficiary.personal_documents.length > maxFilesToUpload
    ) {
      errors_["personal_documents"] =
        "There are too many files. Please delete unnecessary files";
      isError = true;
    }
    setError(errors_);
    setTimeout(() => {
      setError({
        name: "",
        priority: "",
        email: "",
        // TODO: un-comment this field for adding multipe benef. emails
        email_2: "",
        email_3: "",
        phone_number: "",
        last_name: "",
        birth_date: "",
        message: "",
        personal_documents: "",
        priority_amount: "",
      });
    }, 5000);
    return isError;
  };
  const [needToClear, setNeedToClear] = useState(false);

  const handleFile = (e) => {
    const file_array = Array.from(e.target.files);

    // show error if one of loaded files is more than 100mb
    const sizeError = isValidFileSize(file_array);

    if (sizeError) {
      setError({
        file_size: parse(sizeError),
      });
      setTimeout(() => {
        setError({
          file_size: "",
        });
      }, 10000);
      setNeedToClear(true);
      return;
    }

    const filesFreeSlots =
      maxFilesToUpload - beneficiary.personal_documents.length;
    if (
      file_array.length > maxFilesToUpload ||
      filesFreeSlots < file_array.length
    ) {
      setError({
        personal_documents: dublicatedcontent?.dublicatedText218?.replace(
          "file_number",
          maxFilesToUpload
        ),
      });
      setTimeout(() => {
        setError({
          personal_documents: "",
        });
      }, 5000);
      return;
    }

    let asset_files = [];
    file_array.map((newFile) => {
      console.log(newFile);
      let asset_file = {
        id: RandomId(32),
        name: newFile.name,
        size: newFile.size,
        lastModified: newFile.lastModified,
      };
      asset_files.push(asset_file);
      let newBlob = new Blob([newFile], {
        type: newFile.type,
        lastModified: newFile.lastModified,
      });
      let renamedFile = new File([newBlob], asset_file.id, {
        type: newFile.type,
      });
      setFiles((files) => [...files, renamedFile]);
      return null;
    });
    setBeneficiary({
      ...beneficiary,
      personal_documents: beneficiary.personal_documents.concat(asset_files),
    });
  };
  const deleteFile = (fileO) => {
    const new_files = files.filter((file) => file.name !== fileO.id);
    console.log(new_files);
    setFiles(new_files);
    setBeneficiary({
      ...beneficiary,
      personal_documents: beneficiary.personal_documents.filter(
        (file) => file.id !== fileO.id
      ),
      deleted_files: toEdit?.personal_documents.some(
        (file) => file?.id === fileO?.id
      )
        ? [...beneficiary.deleted_files, fileO.id]
        : beneficiary.deleted_files,
    });
  };
  const deleteBeneficiary = async () => {
    await deleteImageHandler();
    beneficiary.personal_documents.map((file_) => {
      return DeleteFile(file_.id)
        .then(() => {
          console.log(`File deleted ${beneficiary.name}:${file_.id}`);
        })
        .catch((e) => {
          console.log(`File not deleted ${beneficiary.name}:${file_.id}`);
        });
    });
    var new_beneficiaries = userData.UserData.beneficiaries.filter(
      (beneficiary_) => beneficiary_.user_id !== beneficiary.user_id
    );
    var new_assets = userData.UserData.assets.map((asset) => {
      return {
        ...asset,
        beneficiaries: asset.beneficiaries.filter(
          (e) => e !== beneficiary.user_id
        ),
      };
    });
    fetch(base_url + "user/beneficiary/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `beneficiary_id=${beneficiary.user_id}`,
      credentials: "include",
    }).then((res) => {});
    var new_issues = handleIssues({
      ...userData.UserData,
      assets: new_assets,
      beneficiaries: new_beneficiaries,
    });
    userData.setUserData({
      ...userData.UserData,
      assets: new_assets,
      beneficiaries: new_beneficiaries,
      issues: new_issues,
    });
    userData.Update(RandomId(10));
    userData.setCustomerUser({
      ...userData.CustomerUser,
      user_status: new_assets.some((e) => e.beneficiaries.length > 0)
        ? "Active"
        : "Inactive",
    });

    setShowConfirmation(false);
    onClose();
    floatMessage(dublicatedcontent?.deleted);
  };

  useEffect(() => {
    if (openAssets) {
      const element = document.getElementById("scrollContainer");
      element.scrollTop = element.scrollHeight;
    }
  }, [openAssets]);

  const trimNameField = (value) => {
    const name = value.trim();
    setBeneficiary({ ...beneficiary, ["name"]: name });
  };

  const clearNameError = () => {
    setDuplicatedName(false);
  };

  /*
    "Identified information".

    The relationship is asked of every beneficiary — an adult sister is a sister
    — so this section is always drawn. The date of birth beside it is the
    MINOR's, and only a minor has one; an adult's is the field further down,
    which is where it has always been.
  */
  const identifiedInformation = (
    <>
      <div className={styles.delay_period} style={{ margin: "20px 0 10px" }}>
        <div className={styles.bold_title}>
          {content.EditBeneficiaryText25}
        </div>
      </div>
      <div className={styles.main_data_upper}>
        {/*
          The relationship column alone, not the row it sits in.

          "Name and relation" grants this field, and it lives down here in
          Identified Information rather than up with the name -- so the
          permission has to reach it separately. The date of birth is its
          neighbour in the same row and is never shared with anybody, which
          is why this marks the column and not the row.
        */}
        <div
          className={styles.upper_left}
          {...editableIf(personSections.identity)}
        >
          {review(
            "relationship",
            content?.EditBeneficiaryText41,
            <div className={styles.delay_period}>
              <div className={styles.input_title}>
                {content.EditBeneficiaryText41}
              </div>
              <Info message={content.EditBeneficiaryText42} />
            </div>
          )}
          <select
            disabled={userData.isFreezed}
            value={beneficiary.relationship}
            onChange={(e) =>
              setBeneficiary({ ...beneficiary, relationship: e.target.value })
            }
            className={`${styles.select} ${reviewMark("relationship")}`}
          >
            {/* Nothing chosen yet is a state of its own, not "Spouse". */}
            <option value="">{content.EditBeneficiaryText49}</option>
            {RELATIONSHIP_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {websiteCurrentLang?.label === "fr" ? option.fr : option.en}
              </option>
            ))}
          </select>
        </div>
        {/*
          The date of birth, whichever one applies: the minor's when the switch
          is on, the beneficiary's own when it is off. One slot rather than two,
          so the field does not move down the form as the switch is thrown — it
          is the same question either way, asked about a different person.

          They remain separate fields underneath, which is why the label, the
          value and the key it writes to all change together.
        */}
        <div className={styles.upper_right}>
          <div className={styles.delay_period}>
            <div className={`${styles.input_title} ${styles.required_field}`}>
              {minor
                ? content.EditBeneficiaryText43
                : content.EditBeneficiaryText26}
            </div>
            <Info
              type={error}
              message={
                minor
                  ? content.EditBeneficiaryText44
                  : content.EditBeneficiaryText27
              }
            />
          </div>
          <CCCalendar
            yyyy={dublicatedcontent?.yyyy}
            mm={dublicatedcontent?.mm}
            dd={dublicatedcontent?.dd}
            handleDate={(e) =>
              setBeneficiary({ ...beneficiary, birth_date: e })
            }
            /*
              `parentDate_`, with the underscore — that is the prop CCCalendar
              destructures. Spelled `parentDate` it is silently ignored, the
              calendar mounts empty, and its mount effect immediately writes
              "//" back over the stored date.
            */
            parentDate_={beneficiary.birth_date}
            className={error.birth_date}
          />
          <div className={styles.error_message}>
            {error.birth_date ? error.birth_date : null}
          </div>
        </div>
      </div>
    </>
  );

  /* The switch that decides which set the form is showing. */
  const minorToggle = (
    <div className={styles.choice} style={{ marginTop: "10px" }}>
      {review(
        "is_minor",
        content?.EditBeneficiaryText39,
        <InfoTitle
          message={content.EditBeneficiaryText40}
          title={content.EditBeneficiaryText39}
          type={"small"}
        />
      )}
      <div disabled={userData.isFreezed} className={styles.choice_container}>
        <span className={styles.switch_option}>
          {dublicatedcontent?.dublicatedText102}
        </span>
        <div className={styles.switch_toggle}>
          <Switch
            checked={minor}
            onClick={() =>
              setBeneficiary({
                ...beneficiary,
                is_minor: minor ? "false" : "true",
              })
            }
          />
        </div>
        <span className={styles.switch_option} style={{ marginRight: "10px" }}>
          {content.EditBeneficiaryText19}
        </span>
      </div>
    </div>
  );

  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={
          width <= 599
            ? {
                height: window.innerHeight - 10,
              }
            : {}
        }
        className={styles.main_box}
      >
        <div onClick={onClose} className={styles.close_logo}></div>
        {/* Read-only for a partner: see canEditRecord. */}
        <ViewOnly active={readOnly}>
        <div className={styles.title}>
          {content.EditBeneficiaryText2} {beneficiary.name}
        </div>
        <div
          /* Scrolls even when the contents are inert. */
          data-viewonly-scroll
          className={`${styles.popup_scrollable} ${styles.popup_scrollable_edit}`}
          id="scrollContainer"
          ref={divElementRef}
        >
          <div
            className={`${styles.shadow_top} ${
              showTopShadow ? styles.active : ""
            }`}
          />
          {/*
            What a partner has asked to change here, above the fields it is
            about. Only the customer sees it: a partner's own copy shows the
            fields, not the question.
          */}
          <div className={styles.main_data} {...editableIf(personSections.identity)}>
            <div className={styles.main_data_upper}>
              <div className={styles.upper_left}>
                <div>
                  {review(
                    "name",
                    content?.EditBeneficiaryText3,
                    <div className={styles.priority_level}>
                      <div
                        className={`${styles.input_title} ${styles.required_field}`}
                      >
                        {content.EditBeneficiaryText3}
                      </div>
                      <Info message={content.EditBeneficiaryText4} />
                    </div>
                  )}
                  <input
                    disabled={userData.isFreezed}
                    onClick={(e) => clearNameError()}
                    onBlur={(e) => trimNameField(e.target.value)}
                    value={beneficiary.name}
                    onChange={(e) =>
                      setBeneficiary({ ...beneficiary, name: e.target.value })
                    }
                    className={`${styles.beneficiary_input} ${
                      error.name ? styles.input_error : ""
                    } ${duplicatedName ? styles.input_error : ""} ${reviewMark(
                      "name"
                    )}`}
                    placeholder={content.EditBeneficiaryText3}
                  ></input>
                  {duplicatedName ? (
                    <div className={styles.error_message}>{duplicateError}</div>
                  ) : null}
                  <div className={styles.error_message}>
                    {error.name ? error.name : null}
                  </div>
                </div>
                <div>
                  {" "}
                  {review(
                    "priority",
                    content?.EditBeneficiaryText5,
                    <div className={styles.priority_level}>
                      <div
                        className={`${styles.input_title} ${styles.required_field}`}
                      >
                        {content.EditBeneficiaryText5}
                      </div>
                      <Info message={content.EditBeneficiaryText6} />
                    </div>
                  )}
                  <select
                    disabled={userData.isFreezed}
                    /*
                      Controlled, not `defaultValue`.

                      An uncontrolled select takes its value once and then
                      ignores the state behind it, so reviewing a proposed
                      priority looked broken: toggling Previous/New moved
                      `beneficiary.priority`, the ring around the photo
                      followed it -- that reads the state on every render --
                      and this dropdown sat on whatever it had been given
                      when the modal opened. The customer was choosing
                      between two values while being shown only one of them.

                      The same is true of accepting a proposal on open: every
                      suggestion arrives accepted, so the value was already
                      the partner's before this was ever touched.

                      String(), because the options are "1" and "2" while a
                      record may hold the number 1 -- a select matches its
                      option by string, and a number silently matches none of
                      them and renders blank.
                    */
                    value={String(beneficiary.priority ?? "")}
                    onChange={(e) => {
                      setBeneficiary({
                        ...beneficiary,
                        priority: e.target.value,
                      });
                    }}
                    className={`${styles.select} ${reviewMark("priority")}`}
                  >
                    <option value="1">{content.EditBeneficiaryText7}</option>
                    <option value="2">{content.EditBeneficiaryText8}</option>
                  </select>
                  <div className={styles.error_message}>
                    {error.priority ? error.priority : null}
                  </div>
                </div>
              </div>
              <div
                className={styles.upper_right}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: "translateY(30px)",
                }}
              >
                {width > 590 && (
                  <div
                    className={
                      String(beneficiary.priority) === "1"
                        ? `${styles.blue_image} ${styles.uploadPictureContainer}`
                        : `${styles.lighter_blue_image} ${styles.uploadPictureContainer}`
                    }
                    {...editableIf(personSections.picture)}
                  >
                    <div className={styles.upload_button_container}>
                      <div className={styles.upload_button}>
                        {initialImage && (
                          <>
                            <div
                              className={styles.previewImageContainer}
                              style={{
                                left: "35px",
                                zIndex: "2",
                                top: "15px",
                                width: "102px",
                                height: "102px",
                              }}
                            >
                              <img
                                src={`data:image/${extension};base64,${previewImage}`}
                                alt="benef. "
                                style={
                                  {
                                    // zIndex: "5",
                                  }
                                }
                                className={styles.previewImage}
                              />
                              <div className={styles.displayDeleteIcon}>
                                <div
                                  className={styles.deletBackdrop}
                                  style={{
                                    width: "102px",
                                    height: "102px",
                                    left: "1px",
                                    top: "0px",
                                    // zIndex: "5",
                                  }}
                                />
                                <div
                                  className={styles.deleteIcon}
                                  onClick={(e) => {
                                    setPreviewImage(null);
                                    setExtension(null);
                                    setImage(null);
                                    setInitialImage(null);
                                    setBeneficiary((prev) => {
                                      return {
                                        ...prev,
                                        profile_avatar: null,
                                      };
                                    });

                                    // deleteImageHandler();
                                  }}
                                  style={
                                    {
                                      // zIndex: "5",
                                    }
                                  }
                                >
                                  <DeleteOutlined />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        <div
                          className={styles.upload_button}
                          style={{
                            top: "14px",
                          }}
                        >
                          {!previewImage && !initialImage && (
                            <img
                              src={uploadButton}
                              alt="upload button"
                              // style={{
                              //   width: "100%",
                              //   height: "100%",
                              // }}
                              style={{
                                width: "115px",
                                height: "115px",
                                transform: "translate(-2px,-2px)",
                              }}
                            />
                          )}
                          {toEdit.user_id && canEditPicture && (
                            <CropperImage
                              dragMode="move"
                              rotatable={true}
                              zoomSlider={false}
                              zoomOnTouch={false}
                              wheelZoomRatio={0.2}
                              zoomOnWheel={true}
                              modalTitle={dublicatedcontent?.edit_image}
                              quality={0.4}
                              classNames={"xxx"}
                              scalable={true}
                              cropShape="round"
                              restore={true}
                            >
                              <UploadProfilePicture
                                disabled={userData.isFreezed ? true : false}
                                multiple={false}
                                maxCount={1}
                                accept=".jpg, .jpeg, .png"
                                beforeUpload={async (file) => {
                                  // const reader = new FileReader();
                                  // reader.readAsDataURL(file);
                                  // setImage(file);
                                  // reader.onload = (e) => {
                                  //   setPreviewImage(reader.result);
                                  // };

                                  setImage(file);
                                  setInitialImage(null);
                                  setPreviewImage(
                                    await encodeFileToBase64(file)
                                  );
                                  const base64code = await encodeFileToBase64(
                                    file
                                  );
                                  setBeneficiary((prev) => {
                                    return {
                                      ...prev,
                                      profile_avatar: base64code,
                                    };
                                  });
                                  // Prevent upload
                                  return false;
                                }}
                                itemRender={(
                                  originNode,
                                  file,
                                  fileList,
                                  { remove }
                                ) => {
                                  return (
                                    <div
                                      className={styles.previewImageContainer}
                                    >
                                      {previewImage && (
                                        <>
                                          <img
                                            src={`data:image/${extension};base64,${previewImage}`}
                                            alt="benef. "
                                            className={styles.previewImage}
                                          />

                                          <div
                                            className={styles.displayDeleteIcon}
                                          >
                                            <div
                                              className={styles.deletBackdrop}
                                            />
                                            <div
                                              className={styles.deleteIcon}
                                              onClick={(e) => {
                                                remove(file);
                                                setImage(null);
                                                setPreviewImage(null);
                                                setPreviewImage(null);
                                                setExtension(null);
                                                setImage(null);
                                                setInitialImage(null);
                                              }}
                                            >
                                              <DeleteOutlined />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  );
                                }}
                              >
                                <div className={styles.upload_trigger}>
                                  {!previewImage && (
                                    <p
                                      className={styles.uploadText}
                                      style={
                                        localStorage.getItem("language") ===
                                        "fr"
                                          ? {
                                              marginTop: "30px",
                                              marginRight: "5px",
                                              width: "110px",
                                            }
                                          : {
                                              marginTop: "20px",
                                              marginRight: "10px",
                                              width: "110px",
                                            }
                                      }
                                    >
                                      {content.EditBeneficiaryText38}
                                    </p>
                                  )}

                                  {previewImage && (
                                    <img
                                      style={{ zIndex: 3 }}
                                      className={styles.editButton}
                                      src={editButton}
                                      alt="edit"
                                    />
                                  )}
                                </div>
                              </UploadProfilePicture>
                            </CropperImage>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {width <= 590 && (
              <div
                className={
                  String(beneficiary.priority) === "1"
                    ? `${styles.blue_image} ${styles.uploadPictureContainer}`
                    : `${styles.lighter_blue_image} ${styles.uploadPictureContainer}`
                }
                {...editableIf(personSections.picture)}
              >
                <div className={styles.upload_button_container}>
                  <div className={styles.upload_button}>
                    <div className={styles.upload_button}>
                      {initialImage && (
                        <>
                          <div
                            className={styles.previewImageContainer}
                            style={{
                              // left: "35px",
                              zIndex: "2",
                              top: "4px",
                              width: "115px",
                              height: "115px",
                            }}
                          >
                            <img
                              src={`data:image/${extension};base64,${previewImage}`}
                              alt="benef. "
                              style={
                                {
                                  // zIndex: "5",
                                }
                              }
                              className={styles.previewImage}
                            />
                            <div className={styles.displayDeleteIcon}>
                              <div
                                className={styles.deletBackdrop}
                                style={{
                                  width: "115px",
                                  height: "115px",
                                  left: "1px",
                                  top: "0px",
                                  // zIndex: "5",
                                }}
                              />
                              <div
                                className={styles.deleteIcon}
                                onClick={(e) => {
                                  setPreviewImage(null);
                                  setExtension(null);
                                  setImage(null);
                                  setInitialImage(null);
                                  setBeneficiary((prev) => {
                                    return {
                                      ...prev,
                                      profile_avatar: null,
                                    };
                                  });

                                  // deleteImageHandler();
                                }}
                                style={
                                  {
                                    // zIndex: "5",
                                  }
                                }
                              >
                                <DeleteOutlined />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {!previewImage && !initialImage && (
                        <img
                          src={uploadButton}
                          alt="upload button"
                          style={{
                            width: "125px",
                            height: "125px",
                            transform: "translate(-2px,-2px)",
                          }}
                        />
                      )}
                      {canEditPicture && (
                        <CropperImage
                          dragMode="move"
                          rotatable={true}
                          zoomSlider={false}
                          zoomOnTouch={false}
                          wheelZoomRatio={0.2}
                          zoomOnWheel={true}
                          modalTitle={dublicatedcontent?.edit_image}
                          quality={0.4}
                          classNames={"xxx"}
                          scalable={true}
                          cropShape="round"
                          restore={true}
                        >
                          <UploadProfilePicture
                            multiple={false}
                            maxCount={1}
                            accept=".jpg, .jpeg, .png"
                            beforeUpload={async (file) => {
                              setImage(file);
                              setInitialImage(null);
                              setPreviewImage(await encodeFileToBase64(file));
                              const base64code = await encodeFileToBase64(file);
                              setBeneficiary((prev) => {
                                return {
                                  ...prev,
                                  profile_avatar: base64code,
                                };
                              });

                              // Prevent upload
                              return false;
                            }}
                            itemRender={(
                              originNode,
                              file,
                              fileList,
                              { remove }
                            ) => {
                              return (
                                <div className={styles.previewImageContainer}>
                                  {previewImage && (
                                    <>
                                      <img
                                        src={`data:image/${extension};base64,${previewImage}`}
                                        alt="benef. "
                                        className={styles.previewImage}
                                      />

                                      <div className={styles.displayDeleteIcon}>
                                        <div className={styles.deletBackdrop} />
                                        <div
                                          className={styles.deleteIcon}
                                          onClick={(e) => {
                                            remove(file);
                                            setImage(null);
                                            setPreviewImage(null);
                                          }}
                                        >
                                          <DeleteOutlined />
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              );
                            }}
                          >
                            {" "}
                            <div className={styles.upload_trigger}>
                              {!previewImage && (
                                <p
                                  className={styles.uploadText}
                                  style={
                                    localStorage.getItem("language") === "fr"
                                      ? {
                                          width: "100px",
                                        }
                                      : {}
                                  }
                                >
                                  {content.EditBeneficiaryText38}
                                </p>
                              )}

                              {previewImage && (
                                <img
                                  className={styles.editButton}
                                  src={editButton}
                                  style={{
                                    bottom: "10px",
                                    right: "10px",
                                    zIndex: "2",
                                  }}
                                  alt="edit"
                                />
                              )}
                            </div>
                          </UploadProfilePicture>
                        </CropperImage>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*
              Below the picture, and in a row of its own -- the same reason
              the minor switch is in one (see just below).

              `.uploadPictureContainer` is `height: 100%` of the column it
              sits in, so ANYTHING added beside the picture stretches it
              taller without making it wider and the circle becomes an
              ellipse. Put in the column, this switch did exactly that and
              shoved the picture off centre as well.

              Rendered only when there is something to ask, so the row costs
              nothing the rest of the time: right-aligned under the picture
              on the wide layout, centred under it on the narrow one, where
              the picture is centred too.
            */}
            {reviewingAvatar && (
              <div
                style={{
                  display: "flex",
                  justifyContent: width > 590 ? "flex-end" : "center",
                  marginTop: "8px",
                }}
              >
                {review("profile_avatar", content?.EditBeneficiaryText38)}
              </div>
            )}
          </div>
          {/*
            The minor switch sits in a row of its own, not in the column above.

            `.uploadPictureContainer` is `height: 100%` of `.upper_right`, which
            stretches to whatever the row's tallest column is — so anything added to
            the left column makes the profile picture TALLER WITHOUT MAKING IT WIDER,
            and the circle becomes an ellipse. Measured: the switch added 24px to the
            column and 24px to the picture's height, nothing to its width.

            Below the row it reads as the design draws it — directly under Priority
            Level, across the left half — and the picture keeps its shape.
          */}
          <div className={styles.main_data_upper}>
            <div className={styles.upper_left}>{minorToggle}</div>
          </div>
          {identifiedInformation}
          <div
            className={styles.delay_period}
            style={{ margin: "20px 0 10px" }}
          >
            <div className={styles.bold_title}>
              {content.EditBeneficiaryText14}
            </div>
            <Info message={content.EditBeneficiaryText15} />
          </div>
          <div
            className={styles.main_data_upper}
            style={{ position: "relative" }}
            {...editableIf(personSections.contact)}
          >
            <div className={styles.upper_left}>
              <div>
                {/*
                  One field, two labels. A minor is written to through a
                  guardian, but it is the same address in the same place doing
                  the same job — so the record keeps one `email`, and only what
                  the form calls it changes.
                */}
                {review(
                  "email",
                  content?.EditBeneficiaryText16,
                  <div
                    className={`${styles.input_title} ${styles.required_field}`}
                  >
                    {minor
                      ? content.EditBeneficiaryText45
                      : content.EditBeneficiaryText16}
                  </div>
                )}
                <input
                  disabled={userData.isFreezed}
                  value={beneficiary.email.toLowerCase()}
                  onChange={(e) =>
                    setBeneficiary({
                      ...beneficiary,
                      email: e.target.value.toLowerCase(),
                    })
                  }
                  className={`${styles.beneficiary_input} ${
                    error.email ? styles.input_error : ""
                  } ${reviewMark("email")}`}
                  placeholder="Email"
                ></input>
                <div className={styles.error_message}>
                  {error.email ? error.email : null}
                </div>
                <div className={styles.choice}>
                  <InfoTitle
                    message={
                      minor
                        ? content.EditBeneficiaryText48
                        : content.EditBeneficiaryText17
                    }
                    title={
                      minor
                        ? content.EditBeneficiaryText47
                        : content.EditBeneficiaryText18
                    }
                    type={"small"}
                  />
                  <div
                    disabled={userData.isFreezed || auth.awareness_email >= 12}
                    className={styles.choice_container}
                  >
                    <span className={styles.switch_option}>
                      {dublicatedcontent?.dublicatedText102}
                    </span>
                    <div className={styles.switch_toggle}>
                      <Switch
                        checked={beneficiary.awareness_status === "true"}
                        onClick={() =>
                          setBeneficiary({
                            ...beneficiary,
                            awareness_status:
                              beneficiary.awareness_status === "true"
                                ? "false"
                                : "true",
                          })
                        }
                      />
                    </div>
                    <span
                      className={styles.switch_option}
                      style={{ marginRight: "10px" }}
                    >
                      {content.EditBeneficiaryText19}
                    </span>
                  </div>
                </div>
                {auth.awareness_email >= 12 && (
                  <div className={styles.error_message}>
                    {content.EditBeneficiaryText20}
                  </div>
                )}
              </div>
              {/* TODO: un-comment this field for adding multipe benef. emails */}
              {benefEmailFields.length > 0 &&
                benefEmailFields.map((item, i) => {
                  return (
                    <NewEmailField
                      dublicatedcontent={dublicatedcontent}
                      edit={true}
                      beneficiary={beneficiary}
                      key={i}
                      error={error}
                      content={content}
                      id={item.id}
                      setBenefEmailFields={setBenefEmailFields}
                      setBeneficiary={setBeneficiary}
                      benefEmailFields={benefEmailFields}
                      minor={minor}
                      renderProposal={review}
                      proposalMark={reviewMark}
                    />
                  );
                })}{" "}
              {benefEmailFields.length < 2 && (
                <div
                  className={styles.addEmail}
                  onClick={() => {
                    // setBenefEmailFields((prev) => [
                    //   ...prev,
                    //   handleAddBenefEmailField(prev.length),
                    // ]);

                    setBenefEmailFields((prev) => {
                      return [
                        ...prev,
                        {
                          new: true,
                          id: Math.random(0).toFixed(4),
                          email: "",
                        },
                      ];
                    });
                  }}
                >
                  <img src={plus_button} alt="plus" />
                  <p>
                    {minor
                      ? dublicatedcontent?.add_another_guardian_email_address
                      : dublicatedcontent?.add_another_beneficiary_email_address}
                  </p>
                </div>
              )}
            </div>

            <div className={styles.upper_right}>
              {review(
                "phone_number",
                content?.EditBeneficiaryText21,
                <div className={styles.input_title}>
                  {minor
                    ? content.EditBeneficiaryText46
                    : content.EditBeneficiaryText21}
                </div>
              )}
              <div
                disabled={userData.isFreezed}
                className={`${styles.phone_div} ${reviewMark(
                  "phone_number",
                  "block"
                )}`}
              >
                <PhoneInput
                  value={beneficiary.phone_number}
                  localization={
                    websiteCurrentLang?.label === "fr"
                      ? fr_phone_countries
                      : undefined
                  }
                  country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                  placeholder={content.EditBeneficiaryText22}
                  onChange={(e) =>
                    setBeneficiary({ ...beneficiary, phone_number: e })
                  }
                />
              </div>
              <div className={styles.error_message}>
                {error.phone_number ? error.phone_number : null}
              </div>
              <InfoTitle
                movetoleft={true}
                message={content.EditBeneficiaryText23}
                title={content.EditBeneficiaryText24}
                type={"small"}
              />
            </div>
          </div>
          <div
            className={styles.input_title}
            style={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <p> {content.EditBeneficiaryText9}</p>{" "}
            {review("message", content?.EditBeneficiaryText9)}
            {openPersonalMessage && (
              <span
                onClick={(e) => {
                  setOpenPersonalMessage(false);
                }}
                /* Collapsing is reading too -- see the opener below. */
                data-viewonly-allow=""
                style={{
                  textDecoration: "underline",
                  color: "var(--color_blue)",
                  fontWeight: "400",
                  cursor: "pointer",
                }}
              >
                {dublicatedcontent?.hide}
              </span>
            )}
          </div>
          {!openPersonalMessage && (
            <div
              onClick={() => {
                setOpenPersonalMessage(true);
              }}
              /*
                Expanding is reading, so it stays live in the read-only view.

                ViewOnly puts `pointer-events: none` over the whole modal and
                this trigger had no exemption, so a partner could not open the
                section at all. It was invisible while the section held
                something -- it opens itself when there is a message or a file
                -- and so only showed up on an EMPTY one, where the partner
                had been granted the row and had no way in to use it.

                `data-viewonly-allow`, not `-editable`: this reveals what was
                already sent and changes nothing. What is inside stays gated
                on the edit flag, as it was.
              */
              data-viewonly-allow=""
              className={styles.personalMessageTrigger}
            >
              <p className={styles.personalMessageTriggerText}>
                {dublicatedcontent.dublicatedText234}
              </p>
              <DownOutlined />
            </div>
          )}
          {openPersonalMessage && (
            <div
              className={styles.personalMessageContainer}
              {...editableIf(personSections.message)}
            >
              <div className={styles.main_data_lower}>
                <textarea
                  style={{
                    backgroundColor: "white",
                  }}
                  disabled={userData.isFreezed}
                  maxlength={maxMessageLength}
                  value={beneficiary.message}
                  ref={textareaRef}
                  placeholder={dublicatedcontent.dublicatedText233}
                  onChange={(e) => {
                    setBeneficiary({ ...beneficiary, message: e.target.value });
                    handleChangeDescription(e);
                  }}
                  className={styles.large_message}
                ></textarea>
                <div className={styles.error_message}>
                  {error.message ? error.message : null}
                </div>
                <div
                  className={`${styles.file_counter} ${
                    beneficiary.message.length === maxMessageLength
                      ? styles.error_text
                      : ""
                  }`}
                >
                  {beneficiary.message.length === maxMessageLength ? (
                    <>{content.EditBeneficiaryText10} </>
                  ) : (
                    ""
                  )}
                  {beneficiary.message.length}/{maxMessageLength}{" "}
                  {dublicatedcontent.dublicatedText93}
                </div>
              </div>
              <div className={styles.upload_doc}>
                {review(
                  "personal_documents",
                  dublicatedcontent?.dublicatedText220,
                  <div className={styles.delay_period}>
                    <div className={styles.bold_title}>
                      {dublicatedcontent?.dublicatedText220}
                    </div>
                    <Info
                      message={
                        "Here, you can upload any document you'd like your beneficiary to see when time comes, whether it's a letter, guide, or any other document of your choice."
                      }
                    />
                  </div>
                )}
                <div className={`${styles.input_title} ${styles.grey_text}`}>
                  {content.EditBeneficiaryText12}
                </div>
                <div className={styles.file_container}>
                  {beneficiary.personal_documents.map((file) => {
                    console.log(file);
                    return (
                      <FileIcon
                        deleteable={!userData.isFreezed && canEditDocuments}
                        OnClick={() =>
                          files.some((file_) => file_?.name === file?.id)
                            ? downloadLocalFile(
                                files.filter(
                                  (file_) => file_?.name === file?.id
                                )[0],
                                file.name
                              )
                            : downloadFile(
                                file.id,
                                file.name,
                                userData.private_key,
                                Progress,
                                dublicatedcontent,
                                /*
                                  Partner view: the bytes are in the
                                  CUSTOMER's folder, so the request has to
                                  say whose.
                                */
                                uploadTarget
                              )
                                .then(() => setModal(null))
                                .catch((e) => {
                                  Progress(`${e} occurred... Try later`);
                                  setTimeout(() => {
                                    setModal(null);
                                  }, 2000);
                                })
                        }
                        key={file.id}
                        filename={file.name}
                        date={file.lastModified}
                        size={file.size}
                        OnDelete={() => deleteFile(file)}
                      ></FileIcon>
                    );
                  })}
                  {beneficiary.personal_documents.length <=
                    maxFilesToUpload - 1 && canEditDocuments && (
                    <Upload
                      disabled={userData.isFreezed}
                      handleFile={(e) => handleFile(e)}
                      clearField={needToClear}
                    />
                  )}
                </div>
                <div className={styles.error_message}>
                  {error.personal_documents ? error.personal_documents : null}
                </div>
                <div className={styles.file_counter}>
                  {content.EditBeneficiaryText13}
                  <div
                    className={`${
                      beneficiary.personal_documents.length >= maxFilesToUpload
                        ? styles.error_text
                        : ""
                    }`}
                  >
                    {beneficiary.personal_documents.length}/{maxFilesToUpload}{" "}
                    {dublicatedcontent?.dublicatedText94}
                  </div>
                </div>
                {error.file_size ? (
                  <div
                    className={`${styles.error_message} ${styles.file_error}`}
                  >
                    {error.file_size}
                  </div>
                ) : null}
              </div>
            </div>
          )}
          <div style={{ position: "relative" }}>
            <div className={styles.delay_period}>
              <div className={styles.bold_title}>
                {content.EditBeneficiaryText28}
              </div>
              <Info message={content.EditBeneficiaryText29} />
              <div
                disabled={userData.isFreezed}
                onClick={() =>
                  setBeneficiary({
                    ...beneficiary,
                    visible_assets: userData.UserData.assets.map((e) => {
                      return e.asset_id;
                    }),
                  })
                }
                className={styles.blue_link}
              >
                {content.EditBeneficiaryText30}
              </div>
              <div className={styles.assets_counter}>
                <span className={styles.assets_selected}>
                  {beneficiary?.visible_assets.length}
                </span>
                /{userData.UserData.assets.length}{" "}
                {content.EditBeneficiaryText31}
              </div>
            </div>
            <div
              disabled={userData.isFreezed}
              className={styles.assets_div}
              {...editableIf(personSections.assets)}
            >
              <div className={styles.assets_container}>
                {width > 590 && canSeeAssets && (
                  <AddNewAsset
                    alreadySelected={beneficiary.visible_assets}
                    assets={userData.UserData.assets}
                    onClick={(asset) =>
                      setBeneficiary({
                        ...beneficiary,
                        visible_assets: [
                          ...beneficiary.visible_assets,
                          asset.asset_id,
                        ],
                      })
                    }
                    openAssets={openAssets}
                  />
                )}
                {beneficiary.visible_assets.map((asset_id) => {
                  let asset_types;
                  userData.UserData.assets.map((asset) => {
                    if (asset.asset_id === asset_id)
                      asset_types = (
                        <AssetType
                          key={asset.asset_id}
                          asset_type={asset.asset_type}
                          asset_name={asset.asset_name}
                          onDelete={() => {
                            setBeneficiary({
                              ...beneficiary,
                              visible_assets: beneficiary.visible_assets.filter(
                                (e) => e !== asset.asset_id
                              ),
                              deleted_assets: [
                                ...beneficiary.deleted_assets,
                                asset.asset_id,
                              ],
                            });
                          }}
                        />
                      );
                    return null;
                  });
                  return asset_types;
                })}
                {width <= 590 && canSeeAssets && (
                  <AddNewAsset
                    alreadySelected={beneficiary.visible_assets}
                    assets={userData.UserData.assets}
                    onClick={(asset) =>
                      setBeneficiary({
                        ...beneficiary,
                        visible_assets: [
                          ...beneficiary.visible_assets,
                          asset.asset_id,
                        ],
                      })
                    }
                    openAssets={openAssets}
                  />
                )}
              </div>
            </div>
            {review(
              "trustees",
              dublicatedcontent?.dublicatedText64,
              <div className={styles.delay_period}>
                <div className={styles.bold_title}>
                  {dublicatedcontent?.dublicatedText64}
                </div>
                <Info
                  position={"top"}
                  message={content.EditBeneficiaryText32}
                />
              </div>
            )}
            <div
              disabled={userData.isFreezed}
              className={`${styles.file_container} ${reviewMark(
                "trustees",
                "block"
              )}`}
              {...editableIf(personSections.trustees)}
            >
              {beneficiary.trustees.map((trustee_id) => {
                let trustee_logo;
                userData.UserData.trustees.map((trustee) => {
                  if (trustee_id === trustee.user_id) {
                    let avatar = null;
                    if (trustee.user_id === trustee_id) {
                      const trusteeAvatar =
                        userData?.UserData?.trustees?.filter(
                          (y) => y.user_id === trustee.user_id
                        )[0]?.profile_avatar;

                      avatar = trusteeAvatar;
                    }
                    // editBeneficiary("trustees", [...beneficiary.trustees, e.user_id])
                    trustee_logo = (
                      <Beneficiarytrustee
                        key={trustee_id}
                        name={trustee.name}
                        avatar={avatar}
                        priority={0}
                        deleatable={true}
                        onDelete={() => {
                          setBeneficiary({
                            ...beneficiary,
                            trustees: beneficiary.trustees.filter(
                              (e) => e !== trustee.user_id
                            ),
                            deleted_trustees: [
                              ...beneficiary.deleted_trustees,
                              trustee.user_id,
                            ],
                          });
                          // editBeneficiary("trustees",beneficiary.trustees.filter(e => e !==trustee.user_id))
                        }}
                      />
                    );
                  }
                  return null;
                });
                return trustee_logo;
              })}
              {beneficiary?.trustees.length <= 24 && canSeeTrustees && (
                <AddBeneficiary
                  specialStyle={true}
                  setShow={() => null}
                  alreadySelected={beneficiary.trustees}
                  user_type={"trustees"}
                  onSelect={(e) => {
                    setBeneficiary({
                      ...beneficiary,
                      trustees: [
                        ...new Set([...beneficiary.trustees, e.user_id]),
                      ],
                    });
                  }}
                />
              )}
            </div>
          </div>
          {partner && (
            <PartnerSharingPerson
              subject="beneficiary"
              value={personSharingValue(beneficiary)}
              onChange={(next) =>
                setBeneficiary((current) => ({ ...current, ...next }))
              }
              disabled={userData.isFreezed}
              partnerName={partner.name}
            />
          )}
          {/*
            The same panel for the PARTNER, stating what they were given.

            `getPartner` is null for them by design -- a partner has no
            partner of their own -- so this is a separate render rather than
            a loosened condition, and it is read-only in two ways: `disabled`
            on every switch, and ViewOnly around the whole modal.

            No disclosure in it. The server already sends these flags to
            them, deliberately, because a row that is shared and EMPTY
            arrives looking exactly like a row that was never shared and
            their screen has to tell the two apart. This stops them having
            to infer it from which fields happen to be editable.

            The master is forced on: they are looking at the record, so it
            was shared with them. It is the one flag the payload leaves out,
            having no reason to repeat what the record's presence says.
          */}
          {userData.partnerReadOnly && (
            <PartnerSharingPerson
              subject="beneficiary"
              viewer="partner"
              value={{
                ...personSharingValue(toEdit),
                share_with_partner: true,
              }}
              onChange={() => {}}
              disabled
            />
          )}
          <div
            className={`${styles.shadow_bottom} ${styles.shadow_bottom_edit} ${
              showBottomShadow ? styles.active : ""
            }`}
          />
        </div>
        </ViewOnly>

        <div className={styles.actions_toolbar}>
          {!readOnly && (
            <div
              onClick={() => {
                setShowConfirmation(true);
              }}
              className={styles.delete_button}
            >
              {content.EditBeneficiaryText35}
            </div>
          )}
          <div onClick={() => onClose()} className={styles.cancel_button}>
            {content.EditBeneficiaryText36}
          </div>
          {(!readOnly || canPropose) && (
          <button
            disabled={userData.isFreezed}
            onClick={(e) => runSave(e)}
            className={styles.save_button}
          >
            {/* A partner is asking, not saving. */}
            {canPropose
              ? approvalContent?.partnerApprovalText23 || "Propose changes"
              : awaitingApproval
              ? approvalContent?.partnerApprovalText14 ||
                content.EditBeneficiaryText37
              : content.EditBeneficiaryText37}
          </button>
          )}
        </div>
        {modal ? (
          <div style={{ position: "relative", zIndex: "5" }}>{modal}</div>
        ) : null}
      </div>

      {/* Out of the scrolling body -- see the note in EditAsset.jsx. */}
      {showConfirmation ? (
        <div style={{ position: "relative", zIndex: "40" }}>
          <Confirmation
            OnConfirm={() => {
              deleteBeneficiary();
              window.scrollTo(0, 0);
            }}
            title={content.EditBeneficiaryText33}
            text={`${content.EditBeneficiaryText34} ${beneficiary.name} ?`}
            onClose={() => setShowConfirmation(false)}
            cancel_button={dublicatedcontent?.dublicatedText184}
            confirm_button={dublicatedcontent?.delete}
          />
        </div>
      ) : null}
    </div>
  );
}

export default EditBeneficiary;
